import { createRoutine } from 'redux-saga-routines';

export const loadUserShortData = createRoutine('LOAD_USER_SHORT_DATA');
export const loadUserDependents = createRoutine('LOAD_USER_DEPENDENTS');
export const loadUserPlans = createRoutine('LOAD_USER_PLANS');
export const loadUserEnrollments = createRoutine('LOAD_USER_ENROLLMENTS');
export const loadUserBeneficiaries = createRoutine('LOAD_USER_BENEFICIARIES');
export const loadUserProfile = createRoutine('LOAD_USER_PROFILE');
